import { Component } from "react";
import { ErrorPageView } from "./ErrorPage";

/**
 * Catches errors thrown while a screen renders, so the person sees a friendly page with a
 * button back to the dashboard instead of a blank screen. It resets itself when the address changes.
 * It uses plain browser navigation so it still works if the router itself is what broke.
 */
export default class ErrorBoundary extends Component {
  state = { failed: false, resetKey: this.props.resetKey };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.resetKey !== state.resetKey) {
      return { failed: false, resetKey: props.resetKey };
    }
    return null;
  }

  componentDidCatch(error) {
    // eslint-disable-next-line no-console
    console.error("Screen failed to render:", error);
  }

  render() {
    if (this.state.failed) {
      return (
        <ErrorPageView
          title="Something went wrong"
          message="This screen couldn't be shown. Your data is safe. Go back to the dashboard and try again."
          onHome={() => window.location.assign("/")}
          onBack={() => window.history.back()}
        />
      );
    }
    return this.props.children;
  }
}
